import * as moment from "moment";

export function calculateDuration(startDate: any, format = 'HH:mm'): any {
    if (startDate) {
        let ms = moment(moment(), 'DD/MM/YYYY HH:mm:ss').diff(moment(startDate, 'DD/MM/YYYY HH:mm:ss'));
        const d = moment.duration(ms);
        return moment.utc(d.asMilliseconds()).format(format);
    }
    return '';
}
export function calculateDurationFromStartToNow(timeServer: number, format = "HH:mm:ss"): any {
    let ms = moment().diff(moment(timeServer));
    const d = moment.duration(ms);
    return moment.utc(d.asMilliseconds()).format(format);
}

export function calculateDurationEnded(startDate: any, endDate: any, format = "HH:mm:ss"): any {
    if (startDate) {
        let ms = moment(endDate).diff(moment(startDate));
        const d = moment.duration(ms);
        return moment.utc(d.asMilliseconds()).format(format);
    }
    return '';
}

export function calculateDurationHHMMSS(startDate: any, format = "HH:mm:ss"): any {
    if (startDate) {
        let ms = moment(moment(), 'DD/MM/YYYY HH:mm:ss').diff(moment(startDate, 'DD/MM/YYYY HH:mm:ss'));
        if (ms < 0) {
            ms = moment(startDate, 'DD/MM/YYYY HH:mm:ss').diff(moment(moment(), 'DD/MM/YYYY HH:mm:ss'));
        }
        const d = moment.duration(ms);
        return moment.utc(d.asMilliseconds()).format(format);
    }
    return '';
}
